import { render, staticRenderFns } from "./EntoDataHOT.vue?vue&type=template&id=228b29d5&"
import script from "./EntoDataHOT.vue?vue&type=script&lang=js&"
export * from "./EntoDataHOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports